var __vue_script__, __vue_template__
require("!!vue-style-loader!css-loader!./../node_modules/vue-loader/lib/style-rewriter.js?id=_v-1491c0c9&scoped=true!./../node_modules/vue-loader/lib/selector.js?type=style&index=0!./Data.vue")
__vue_script__ = require("!!babel-loader?presets[]=es2015&plugins[]=transform-runtime&comments=false!./../node_modules/vue-loader/lib/selector.js?type=script&index=0!./Data.vue")
__vue_template__ = require("!!vue-html-loader!./../node_modules/vue-loader/lib/template-rewriter.js?id=_v-1491c0c9!./../node_modules/vue-loader/lib/selector.js?type=template&index=0!./Data.vue")
module.exports = __vue_script__ || {}
if (module.exports.__esModule) module.exports = module.exports.default
if (__vue_template__) {
(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
}



/*****************
 ** WEBPACK FOOTER
 ** ./demo/Data.vue
 ** module id = 48
 ** module chunks = 0
 **/